import { render } from "./KRSubHeaderLayout.vue?vue&type=template&id=8c2f6a38&scoped=true"
import script from "./KRSubHeaderLayout.vue?vue&type=script&lang=js"
export * from "./KRSubHeaderLayout.vue?vue&type=script&lang=js"

import "./KRSubHeaderLayout.vue?vue&type=style&index=0&id=8c2f6a38&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8c2f6a38"

export default script